import { DriveItemListOrigin } from '../containers/DriveItemListPage/constants';

export const pathHashbang = '(!/)';

export enum RoutePath {
	Default = '(!/)',
	Home = '(!/)home',
	Authentication = '(!/)authentication',
	ParametersPage = '(!/)parameters',
	ProfilePage = '(!/)profile',
	DriveItemListPage = '(!/)list/:origin(/:originParam)',
	TheaterList = '(!/)list/:origin(/:originParam)/theater/:driveItemId',
	Theater = '(!/)theater/:driveItemId',
	DriveItemDetailPage = '(!/)detail(/:folderId)/:driveItemId',
	NotFound = '*',
	StaticPage = '(!/)page/:component',
	Editor = '(!/)editor/:clientId/:resourceId',
	ProposalStatsPage = '(!/)proposal_stats',
}

export interface RouteParamsDriveItemListPage {
	origin: DriveItemListOrigin;
	originParam: string;
}

export interface RouteParamsTheater extends RouteParamsDriveItemListPage {
	driveItemId: string;
}

export interface RouteParamsDriveItemDetailPage {
	driveItemId: string;
}

export interface RouteParamsStaticPage {
	component: string;
}

export interface RouteParamsEditor {
	clientId: number;
	resourceId: number;
}

export type RouteParams = RouteParamsDriveItemListPage | RouteParamsTheater | RouteParamsDriveItemDetailPage | RouteParamsStaticPage | RouteParamsEditor | {};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/routes/constants.ts